import { CompleteSpeedBands, SpeedBands } from "../api/insights"

export const getSpeedingBreakdownLineValues = (speedBands: SpeedBands): CompleteSpeedBands => {
  const { minorSpeedBandPercentage, majorSpeedBandPercentage, criticalSpeedBandPercentage } = speedBands
  const total = minorSpeedBandPercentage + majorSpeedBandPercentage + criticalSpeedBandPercentage

  return {
    minorSpeedBandPercentage,
    majorSpeedBandPercentage,
    criticalSpeedBandPercentage,
    lawfulSpeedBandPercentage: 1 - total,
  }
}
